/* eslint-disable @typescript-eslint/no-extraneous-class */
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "lib-overlay-container",
	templateUrl: "./overlay-container.component.html",
	styleUrl: "./overlay-container.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.ShadowDom
})
export class OverlayContainerComponent {}
